import { buttonRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { Skeleton } from "../Skeleton";

const TITLE_LINE_HEIGHT = 20;
const DESCRIPTION_LINE_HEIGHT = 16;
const DONUT_SIZE = 56;
const CTA_WIDTH = 112;
const CTA_HEIGHT = 40;
const ROW_HEIGHT = 84;

export const MasteryListItemSkeleton = () => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			gap={16}
			paddingHorizontal={16}
			minHeight={ROW_HEIGHT}
		>
			<Skeleton size={DONUT_SIZE} variant="circle" />
			<Box flex={1} minWidth={0}>
				<Box height={TITLE_LINE_HEIGHT} justifyContent="center">
					<Skeleton width={isMobile ? "75%" : "50%"} height={14} />
				</Box>
				<Box height={DESCRIPTION_LINE_HEIGHT} justifyContent="center">
					<Skeleton width={isMobile ? "50%" : "35%"} height={12} />
				</Box>
			</Box>
			<Skeleton
				width={CTA_WIDTH}
				height={CTA_HEIGHT}
				borderRadius={theme.roundness * buttonRoundnessMultiplier}
			/>
		</Box>
	);
};
